const CrunchyrollRoutes = [
    {
        path: '/crunchyroll-price-in-different-countries',
        name: 'Crunchyroll',
        component: () => import(/* webpackChunkName: "crunchyroll" */'@/views/3-in-1/crunchyroll/Crunchyroll.vue')
    },
    {
        path: '/en/crunchyroll-price-in-different-countries',
        name: 'CrunchyrollEN',
        component: () => import(/* webpackChunkName: "crunchyroll" */'@/views/3-in-1/crunchyroll/Crunchyroll.vue')
    },
    {
        path: '/ru/crunchyroll-price-in-different-countries',
        name: 'CrunchyrollRU',
        component: () => import(/* webpackChunkName: "crunchyroll" */'@/views/3-in-1/crunchyroll/Crunchyroll.vue')
    },
    {
        path: '/cn/crunchyroll-price-in-different-countries',
        name: 'CrunchyrollCN',
        component: () => import(/* webpackChunkName: "crunchyroll" */'@/views/3-in-1/crunchyroll/Crunchyroll.vue')
    },
    {
        path: '/de/crunchyroll-price-in-different-countries',
        name: 'CrunchyrollDE',
        component: () => import(/* webpackChunkName: "crunchyroll" */'@/views/3-in-1/crunchyroll/Crunchyroll.vue')
    },
    {
        path: '/es/crunchyroll-price-in-different-countries',
        name: 'CrunchyrollES',
        component: () => import(/* webpackChunkName: "crunchyroll" */'@/views/3-in-1/crunchyroll/Crunchyroll.vue')
    },
    {
        path: '/it/crunchyroll-price-in-different-countries',
        name: 'CrunchyrollIT',
        component: () => import(/* webpackChunkName: "crunchyroll" */'@/views/3-in-1/crunchyroll/Crunchyroll.vue')
    }
]

export default CrunchyrollRoutes;
